/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./zrc/scripts/templates/product/product-main.js":
/*!*******************************************************!*\
  !*** ./zrc/scripts/templates/product/product-main.js ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var swiper_js_swiper_esm__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! swiper/js/swiper.esm */ "./node_modules/swiper/js/swiper.esm.js");
/* eslint-disable no-undef */

class Prodcut extends window.HTMLElement {
  constructor() {
    super();
    this.container = this;
    this.carousel();
    this.checkHeaderHeight();

    // window.setInterval(() => {
    //   this.checkOverflow();
    // }, 100);

    this.swatches();
    this.quantitySelector();
    this.templateDescriptions();
    this.preorderButton();
    this.removeEmptyDivs();
  }
  carousel() {
    var slidesLength = $('.product-carousel-container').data('slides');
    swiper_js_swiper_esm__WEBPACK_IMPORTED_MODULE_0__.Swiper.use([swiper_js_swiper_esm__WEBPACK_IMPORTED_MODULE_0__.Pagination, swiper_js_swiper_esm__WEBPACK_IMPORTED_MODULE_0__.Navigation, swiper_js_swiper_esm__WEBPACK_IMPORTED_MODULE_0__.Thumbs]);
    var swiperThumbnails = new swiper_js_swiper_esm__WEBPACK_IMPORTED_MODULE_0__.Swiper('.product-thumbnails-grid', {
      longSwipesRatio: 0,
      observer: true,
      observeParents: true,
      resistanceRatio: 0,
      slidesPerView: 'auto',
      threshold: 11,
      watchOverflow: true
    });
    var swiper = new swiper_js_swiper_esm__WEBPACK_IMPORTED_MODULE_0__.Swiper('.product-carousel-container', {
      longSwipesRatio: 0,
      loop: slidesLength > 1,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      observer: true,
      observeParents: true,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets'
      },
      resistanceRatio: 0,
      slidesPerView: 'auto',
      thumbs: {
        swiper: slidesLength > 1 ? swiperThumbnails : ''
      },
      watchOverflow: true,
      breakpoints: {
        0: {
          spaceBetween: 25
        },
        791: {
          spaceBetween: 0
        }
      }
    });

    // eslint-disable-next-line shopify/prefer-early-return
    $(this.container).on('variantChange', event => {
      if (event.variant.featured_media !== undefined) {
        var currentVariantMediaId = event.variant.featured_media.id;
        var variantSlide = $('.product-carousel-container').find(".swiper-slide[data-media-id=\"".concat(currentVariantMediaId, "\"]:not(.swiper-slide-duplicate)"));
        if (variantSlide.length > 0) {
          var swiperIndex = parseInt($(variantSlide[0]).attr('data-swiper-slide-index'), 10);
          // swiper.slick('slickGoTo', swiperIndex, false);
          swiper.slideToLoop(swiperIndex);
        }
      }

      // window.console.log(`¿QUÉ ES?: ${JSON.stringify(event)}`);
    });
    swiper.on('slideChange', () => {
      $('.product-carousel-video-slide video').each(function () {
        this.pause();
      });
    });
    swiper.on('transitionEnd', () => {
      $('.product-carousel-video-slide.swiper-slide-active video').each(function () {
        this.play();
      });
    });
  }
  checkHeaderHeight() {
    function getHeight() {
      var headerHeight = document.querySelector('.header-section-wrapper').offsetHeight;
      var carouselSection = document.querySelector('.product-carousel-section');
      carouselSection.style.top = "".concat(headerHeight, "px");
    }
    window.setInterval(() => {
      getHeight();
    }, 300);
  }

  // checkOverflow() {
  //   function isOverflown(element) {
  //     return (
  //       element.scrollHeight > element.clientHeight ||
  //       element.scrollWidth > element.clientWidth
  //     );
  //   }

  //   const filterContainer = document.getElementsByClassName('checkOverflow');

  //   for (let i = 0; i < filterContainer.length; i++) {
  //     const theFilter = filterContainer[i];

  //     if (isOverflown(theFilter)) {
  //       theFilter.parentNode.classList.add('is-scrollable');
  //     } else {
  //       theFilter.parentNode.classList.remove('is-scrollable');
  //     }
  //   }
  // },
  swatches() {
    $('.product-swatch').click(function () {
      $(".product-swatch.is-active").removeClass("is-active");
      if (!$(this).hasClass('is-active')) {
        $(this).addClass("is-active");
      }
    });

    // if ($('.product-swatch').hasClass('is-active')) {
    //   $('.product-swatch.is-active').prev('.product-swatch-input').prop("checked", true);
    //   // $('.product-swatch.is-active').prev('.product-swatch-input').addClass('anamichula');
    // }

    // $(".product-swatches-content :input").each(function() {
    //   if ($(this).is(":checked")) {
    //     $(this).addClass("miHermosAna");
    //   } else {
    //     $(this).removeClass("miHermosAna");
    //   }
    // });
  }
  quantitySelector() {
    var control = $('.product-quantity-button');
    control.click(event => {
      var {
        action
      } = event.target.dataset;
      var input = $('.product-quantity-number');
      var currentQty = parseInt(input.val(), 10);
      if (action === 'plus') {
        input.val(currentQty += 1);
      }
      if (action === 'minus' && currentQty > 1) {
        input.val(currentQty -= 1);
      }
    });
  }
  templateDescriptions() {
    var util = {
      cleanString(str) {
        var newString = str.toLowerCase().replace('á', 'a').replace('é', 'e').replace('í', 'i').replace('ó', 'o').replace('ú', 'u').replace('ñ', 'n').replace('\n', '').replace(new RegExp(' ', 'g'), '-');
        return newString;
      }
    };
    function showTabInfo(tab) {
      var tabContent = tab.next();
      $('.product-tab-indicator').text('+');
      if (tab.hasClass('js-is-open')) {
        tabContent.stop().slideUp();
        tab.removeClass('js-is-open');
      } else {
        $('.product-tab-content').stop().slideUp();
        $('.product-tab').removeClass('js-is-open');
        tabContent.stop().slideDown();
        tab.toggleClass('js-is-open');
        tab.children('.product-tab-indicator').text('-');
      }
    }
    $('.product-tab').click(function () {
      showTabInfo($(this));
    });
    var parent = $('#product-description-hidden');
    var titles = parent.find('h6');
    titles.each((index, el) => {
      var title = $(el).text();
      var content = $(el).nextUntil('h6');
      var data = util.cleanString(title);
      $("[data-".concat(data, "]")).append(content);
    });
  }
  preorderButton() {
    var checkLoaded = window.setInterval(() => {
      if (typeof window.pn.running === 'undefined') {
        window.console.log('');
      } else {
        window.clearInterval(checkLoaded);
        document.querySelector('.product-submit-container').classList.remove('not-loaded');
      }
    }, 100);
    var elemToObserve = document.querySelector('.product-submit');
    var prevClassState = elemToObserve.classList.contains('sbb');
    var observer = new MutationObserver(mutations => {
      // eslint-disable-next-line shopify/prefer-early-return
      mutations.forEach(mutation => {
        if (mutation.attributeName === "class") {
          var currentClassState = mutation.target.classList.contains('sbb');
          if (prevClassState !== currentClassState) {
            prevClassState = currentClassState;
            if (currentClassState) {
              document.querySelector('.product-submit-grid').classList.add('preorder-button-container');
              var preorderDescription = document.querySelector('.preorder-description');
              var preorderDescriptionHeightObserver = new ResizeObserver(thePreorderDescription => {
                document.documentElement.style.setProperty('--preorder-description-height', "".concat(thePreorderDescription[0].target.clientHeight, "px"));
              });
              preorderDescriptionHeightObserver.observe(preorderDescription);
            } else {
              window.console.log("");
            }
          }
        }
      });
    });
    observer.observe(elemToObserve, {
      attributes: true
    });
  }
  removeEmptyDivs() {
    $('.product-tab-content').each(function () {
      if ($(this).text() === '' || $(this).length === 0) {
        $(this).parent('.product-tab-container').remove();
      }
    });

    // eslint-disable-next-line shopify/prefer-early-return
    $('.product-description').each(function () {
      if ($(this).text() === '' || $(this).length === 0) {
        $(this).remove();
        $('.product-tabs-section').addClass('without-description');
      }
    });
    $('.product-tabs-section').each(function () {
      if ($(this).text() === '' || $(this).length === 0) {
        $(this).remove();
      }
    });
  }
}
if (window.customElements.get('product-section') == null) {
  window.customElements.define('product-section', Prodcut);
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		if(__webpack_module_cache__[moduleId]) {
/******/ 			return __webpack_module_cache__[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/******/ 	// the startup function
/******/ 	// It's empty as some runtime module handles the default behavior
/******/ 	__webpack_require__.x = x => {};
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// Promise = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"product": 0
/******/ 		};
/******/ 		
/******/ 		var deferredModules = [
/******/ 			["./zrc/scripts/templates/product/product-main.js","commons"]
/******/ 		];
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		var checkDeferredModules = x => {};
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime, executeModules] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0, resolves = [];
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					resolves.push(installedChunks[chunkId][0]);
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			for(moduleId in moreModules) {
/******/ 				if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 					__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 				}
/******/ 			}
/******/ 			if(runtime) runtime(__webpack_require__);
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			while(resolves.length) {
/******/ 				resolves.shift()();
/******/ 			}
/******/ 		
/******/ 			// add entry modules from loaded chunk to deferred list
/******/ 			if(executeModules) deferredModules.push.apply(deferredModules, executeModules);
/******/ 		
/******/ 			// run deferred modules when all chunks ready
/******/ 			return checkDeferredModules();
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkgetmore_workflow"] = self["webpackChunkgetmore_workflow"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 		
/******/ 		function checkDeferredModulesImpl() {
/******/ 			var result;
/******/ 			for(var i = 0; i < deferredModules.length; i++) {
/******/ 				var deferredModule = deferredModules[i];
/******/ 				var fulfilled = true;
/******/ 				for(var j = 1; j < deferredModule.length; j++) {
/******/ 					var depId = deferredModule[j];
/******/ 					if(installedChunks[depId] !== 0) fulfilled = false;
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferredModules.splice(i--, 1);
/******/ 					result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
/******/ 				}
/******/ 			}
/******/ 			if(deferredModules.length === 0) {
/******/ 				__webpack_require__.x();
/******/ 				__webpack_require__.x = x => {};
/******/ 			}
/******/ 			return result;
/******/ 		}
/******/ 		var startup = __webpack_require__.x;
/******/ 		__webpack_require__.x = () => {
/******/ 			// reset startup function so it can be called again when more startup code is added
/******/ 			__webpack_require__.x = startup || (x => {});
/******/ 			return (checkDeferredModules = checkDeferredModulesImpl)();
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	// run startup
/******/ 	__webpack_require__.x();
/******/ })()
;